module.exports = __webpack_public_path__ + "img/156.c50c47f1.jpg";